import { Component, Element, h, Prop, State } from '@stencil/core';
import { getSlottedElements } from '../../utils/slotted';

@Component({
	shadow: true,
	styleUrl: 'zds-alert.scss',
	tag: 'zds-alert',
})
export class ZdsAlert {
	descriptionSlotelement: HTMLSlotElement;

	@Element() hostElement: HTMLDivElement;

	@Prop() hideIcon: boolean = false;
	@Prop() type: 'error' | 'info' | 'success' | 'warning' = 'info';

	@State() hasBodyContent: boolean;

	componentDidLoad() {
		this.hasBodyContent = getSlottedElements(this.descriptionSlotelement).length > 0;
	}

	renderIcon() {
		if (this.hideIcon) return null;

		const iconMapping = {
			error: 'triangle-exclamation',
			info: 'circle-info',
			success: 'check',
			warning: 'triangle-exclamation',
		};

		return <zds-icon class="zds-alert__icon" name={iconMapping[this.type]} library="fa-solid" size="sm" />;
	}

	render() {
		return (
			<div class={'zds-alert zds-alert--' + this.type}>
				<div class="zds-alert__title">
					{this.renderIcon()}
					<slot></slot>
				</div>
				{this.hasBodyContent && <zds-divider light></zds-divider>}
				<div class="zds-alert__body">
					<slot name="body" ref={(element) => (this.descriptionSlotelement = element as HTMLSlotElement)} />
				</div>
			</div>
		);
	}
}
